<template>
  <div class="app-container">
    <AppBarAuth />
    <div class="content-container">
      <SideNavbar />
      <v-main class="main-content">
        <ScheduleWarningDialog v-if="warningDialog" v-bind:endDate="endDate" />
        <AnimatedVAlertDialog
          v-if="noticeMessages.length > 0"
          v-bind:notificationMessages="noticeMessages"
        />
        <v-overlay :value="overlay" v-if="overlay" z-index="1000">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-card class="mx-auto mt-15" max-width="500" v-if="tokenExpired">
          <v-img max-height="150" src="../assets/APT_LogoR.png"></v-img>
          <v-card-title class="ma-1 font-weight-medium justify-center">
            Your Token has Expired, please login again
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="reLoginPage()">Re-Login</v-btn>
          </v-card-actions>
        </v-card>
        <router-view v-else></router-view>

        <!-- ChatBox Toggle Component -->
        <ChatBoxToggle></ChatBoxToggle>
      </v-main>
      <v-dialog persistent v-model="updatePasswordDialog" max-width="35rem">
        <v-card class="pa-2">
          <v-form>
            <v-col>
              <v-text-field
                v-model="password1"
                :type="showPswrd ? 'text' : 'password'"
                placeholder="Enter Password"
                :rules="createUserValidation.passwordRules"
                outlined
                dense
                :append-icon="!showPswrd ? 'mdi-eye-off' : 'mdi-eye'"
                @click:append="showPswrd = !showPswrd"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                v-model="password2"
                :type="showPswrd ? 'text' : 'password'"
                placeholder="Re-Enter Password"
                :rules="createUserValidation.passwordRules"
                outlined
                dense
                :append-icon="!showPswrd ? 'mdi-eye-off' : 'mdi-eye'"
                @click:append="showPswrd = !showPswrd"
              ></v-text-field>
            </v-col>
          </v-form>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="updatePassword()"> Save </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <!-- <AppFooter /> -->
  </div>
</template>

<script>
import Vue from "vue";
import AppBarAuth from "../components/AppBarAuth.vue";
import SideNavbar from "../components/SideNavbar.vue";
import AppFooter from "../components/AppFooter.vue";
import ChatBoxToggle from "../components/ChatBoxToggle.vue";
import AnimatedVAlertDialog from "./dialogComponents/AnimatedVAlertDialog.vue";
import ScheduleWarningDialog from "../components/ScheduleWarningDialog.vue";
import { mapGetters, mapMutations } from "vuex";
import {
  SET_OVERLAY_VALUE,
  SET_TOKEN_EXPIRED,
  SET_USER_PROFILE,
  SET_PARAMS_VALUE,
} from "@/store/mutations";

import {
  GET_OVERLAY_VALUE,
  GET_TOKEN,
  GET_TOKEN_EXPIRED,
  GET_USER_PROFILE,
} from "@/store/getters";
import {
  USER_TYPE_SALES_MANAGER,
  USER_TYPE_STUDENT,
  USER_TYPE_TEACHER,
} from "@/common/constants";
import {
  BASE_URL,
  GET_NOTICE_BOARD_MESSAGES,
  UPDATE_PASSWORD,
} from "@/common/apiEndpoints";
import {
  USER_PASSWORD_CHANGED_SUCCESSFULLY,
  PASSWORDS_DONT_MATCH,
} from "@/common/apiMessageConstant";
import axios from "axios";
import { getAxiosOptions } from "@/common/utility";
export default Vue.extend({
  data() {
    return {
      showPswrd: false,
      studentUserId: "",
      password1: "",
      password2: "",
      updatePasswordDialog: false,
      USER_TYPE_STUDENT: USER_TYPE_STUDENT,
      USER_TYPE_TEACHER: USER_TYPE_TEACHER,
      USER_TYPE_SALES_MANAGER: USER_TYPE_SALES_MANAGER,
      relogin: false,
      fab: false,
      alertState: false,
      noticeMessages: [],
      interval: {},
      isSmall: false,
      warningDialog: false,
      endDate: "",
      createUserValidation: {
        passwordRules: [
          (v) => !!v || "Password is required",
          (v) => /[a-z]+/.test(v) || "One lowercase letter required",
          (v) => /[A-Z]+/.test(v) || "One uppercase letter required",
          (v) => /[0-9]+/.test(v) || "One number required",
          (v) => /.{8,}/.test(v) || "8 characters minimum",
        ],
      },
    };
  },
  components: {
    SideNavbar,
    AppBarAuth,
    AppFooter,
    ChatBoxToggle,
    AnimatedVAlertDialog,
    ScheduleWarningDialog,
  },
  watch: {
    userProfile: {
      handler(userProfile) {
        if (this.$router.history.current.path == "/home") {
          if (userProfile.userType === this.USER_TYPE_STUDENT) {
            if (userProfile.changePassword) {
              this.openUpdatePasswordDialog(userProfile);
            }
            if (userProfile.registrationCompleted) {
              // if (!document.fullscreenElement) {
              //   document.documentElement.requestFullscreen();
              // }
              this.$router.push({ path: "/home/dashboard" });
            } else {
              this.$router.push({ path: "/home/student/on-board" });
            }
          } else if (userProfile.userType === this.USER_TYPE_TEACHER) {
            if (!userProfile.registrationCompleted) {
              this.$router.push({ path: "/home/teacher/on-board" });
            } else if (this.moveToUpdateSchedule()) {
              var paramsValue = {};
              paramsValue.isScheduleExpired = true;
              paramsValue.endDate = this.endDate;
              this.setParams(paramsValue);
              this.$router.push({ path: "/home/update-schedule" });
            } else {
              this.$router.push({ path: "/home/dashboard" });
            }
          } else if (userProfile.userType === this.USER_TYPE_SALES_MANAGER) {
            this.$router.push({ path: "/home/uk/registrations" });
          } else {
            this.$router.push({ path: "/home/dashboard" });
          }
        }
      },
    },
  },
  mounted() {
    if (
      this.userProfile.userType === this.USER_TYPE_STUDENT &&
      this.userProfile.changePassword
    ) {
      this.openUpdatePasswordDialog(this.userProfile);
    }
    if (this.interval) {
      clearInterval(this.interval);
    }
    // this.intervalFunction();
  },
  beforeDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  },
  computed: {
    ...mapGetters({
      userProfile: `schoolModule/${GET_USER_PROFILE}`,
      overlay: `schoolModule/${GET_OVERLAY_VALUE}`,
      tokenExpired: `schoolModule/${GET_TOKEN_EXPIRED}`,
      token: `schoolModule/${GET_TOKEN}`,
    }),
  },
  methods: {
    ...mapMutations({
      setOverlayValue: `schoolModule/${SET_OVERLAY_VALUE}`,
      setTokenExpired: `schoolModule/${SET_TOKEN_EXPIRED}`,
      setUserProfile: `schoolModule/${SET_USER_PROFILE}`,
      setParams: `schoolModule/${SET_PARAMS_VALUE}`,
    }),

    openUpdatePasswordDialog(userProfile) {
      this.updatePasswordDialog = true;
      this.studentUserId = userProfile.userId;
    },
    closeUpdatePasswordDialog() {
      this.updatePasswordDialog = false;
      this.password1 = "";
      this.password2 = "";
    },
    updatePassword() {
      if (this.password1 === this.password2) {
        let payload = {};
        payload.userId = this.studentUserId;
        payload.password = this.password1;
        let url = UPDATE_PASSWORD;
        this.setOverlayValue(true);
        axios
          .post(url, payload, getAxiosOptions(BASE_URL, this.token))
          .then((res) => {
            this.closeUpdatePasswordDialog();
            this.password1 = "";
            this.password2 = "";
            this.setOverlayValue(false);
            this.setApiSuccess(USER_PASSWORD_CHANGED_SUCCESSFULLY);
          })
          .catch((error) => {
            this.setOverlayValue(false);
          });
      } else {
        this.setApiError(PASSWORDS_DONT_MATCH);
      }
    },
    reLoginPage() {
      sessionStorage.clear();
      this.setParams({});
      this.setTokenExpired(true);
      this.setOverlayValue(false);
      this.setUserProfile({});
      this.$router.push({ path: "/login" });
    },
    toggleAlert() {
      this.alertState = !this.alertState;
      // console.log(this.alertState);
    },
    intervalFunction: function () {
      if (this.interval) {
        clearInterval(this.interval);
      }
      var oThis = this;
      this.interval = setInterval(function () {
        oThis.messages = oThis.getNoticeBoardMessages();
      }, 15000);
    },
    getNoticeBoardMessages() {
      if (
        !this.tokenExpired &&
        (this.userProfile.userType === this.USER_TYPE_STUDENT ||
          this.userProfile.userType === this.USER_TYPE_TEACHER) &&
        this.userProfile.registrationCompleted
      ) {
        let url = GET_NOTICE_BOARD_MESSAGES;
        axios
          .get(url, getAxiosOptions(BASE_URL, this.token))
          .then((res) => {
            this.noticeMessages = res.data.messages;
          })
          .catch((error) => {
            error = error.errorMessage;
          });
      }
    },
    moveToUpdateSchedule() {
      if (
        this.userProfile.teacher &&
        this.userProfile.teacher.schedule &&
        this.userProfile.teacher.schedule.length > 0
      ) {
        // var lastIndex = this.userProfile.teacher.schedule.length - 1;
        // var endTime = new Date(
        //   this.userProfile.teacher.schedule[lastIndex].endDateTime
        // ).getTime();
        // this.endDate = new Date(
        //   this.userProfile.teacher.schedule[lastIndex].endDateTime
        // );
        this.endDate = new Date(
          Math.max(
            ...this.userProfile.teacher.schedule.map(
              (dateTime) => new Date(dateTime.endDateTime)
            )
          )
        );
        var endTime = this.endDate.getTime();
        var currentTime = new Date().getTime();
        if (endTime < currentTime) {
          return true;
        } else if (endTime < currentTime + 7 * 24 * 60 * 60 * 1000) {
          this.warningDialog = true;
          return false;
        } else {
          return false;
        }
      }
      return true;
    },
  },
});
</script>
<style>
.chatbox-fab {
  z-index: 10;
}

.app-container {
  display: flex;
  flex-direction: row;
  height: 100vh;
}

.content-container {
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  overflow: hidden !important;
  scrollbar-width: none !important;
  -ms-overflow-style: none;
  background-color: #f4f7fe;
}

.main-content {
  background-color: #f4f7fe;
  border: 0.1rem solid #d5d7e2;
  border-radius: 0.5rem !important;
  margin-left: 16.7rem !important;
  margin-top: 4.6rem !important;
  margin-bottom: 0.5rem !important;
  margin-right: 0.5rem !important;
  padding: 0 !important;
  flex-grow: 1;
  overflow-y: auto !important;
  overflow-x: hidden !important;
  -ms-overflow-style: none;
  max-width: calc(100% - 17.2rem);
}
</style>
